export const roles = [
  { text: "System Administrator", value: "admin" },
  { text: "Manager", value: "manager" },
  { text: "Technician", value: "technician" },
  { text: "Client", value: "client" },
];
